import React, { useContext, useState } from "react";
import { Modal } from "antd";
import { UploadContext } from "../../Context/UploadContext";
const Modals = ({ title, steps, resetSelected }) => {
	const [isModalOpen, setIsModalOpen] = useState(true);
	const { setIsUploading } = useContext(UploadContext);
	const handleOk = () => {
		resetSelected("");
		setIsModalOpen(false);
	};
	const handleModal = () => {
		setIsUploading(false);
	};
	return (
		<>
			<Modal
				closable={true}
				title={title}
				open={isModalOpen}
				width={1000}
				onOk={handleOk}
				onCancel={handleModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<div>{React.cloneElement(steps, { handler: handleModal })}</div>
			</Modal>
		</>
	);
};
export default Modals;
